import React, {Component, Fragment} from 'react';
import ReactGA from 'react-ga';
import {Helmet} from "react-helmet";
import NavTop from '../../containers/NavTop/NavTop';
import {BackTop} from 'antd';
import {Divider} from 'antd';
import './PrivacyPage.css';

class PrivacyPage extends Component {

  constructor(props){
    super(props);
    ReactGA.pageview(window.location.pathname + window.location.search);
  }
  
  render() {
    return (
      <Fragment>
        <Helmet>
            <meta charSet="utf-8" />
            <title>RealTimeTouch.com - Privacy</title>
            <link rel="canonical" href="http://www.realtimetouch.com/privacy/" />
        </Helmet>
        <NavTop pageOn={this.props.pageOn} />
        <BackTop />
        <div className="PrivacyPage--subnavbar-container mobileoff">
          <div className="PrivacyPage--subnavbar center mobileoff">
          </div>  
          <div className="PrivacyPage--subnavbar2 center mobileoff">
          </div>
          <h2 className="PrivacyPage--subnavbar-headline mobileoff font-special-heading">Real Time Touch: Privacy Policy</h2>
        </div>
        <div className="PrivacyPage--container">
          <div className="PrivacyPage--subheadline-container">
            <div className="mobileon mobile-heading2">Real Time Touch: Privacy Page</div>
            
            <h4 className="PrivacyPage--subheadline">Please view our privacy policy below.</h4>
            <p className="PrivacyPage--body">If any questions, please contact us at our <a href="/contact/">contact form</a>.</p>
          </div>
        <div className=""><Divider /></div>
          <div className="PrivacyPage--content">
            <h2>Privacy Policy</h2>
            <p>
            Your privacy and security are important to us.
            </p>
            <p>
            We recognize and respect your need for privacy and security as you visit our site. When you visit our site to view any pages, read product information, or use our on-line calculators and tools, you do so without telling us who you are and without revealing any personal information. While we do not collect identifying information about visitors to our site, we do use standard software to collect information for the strict purpose of tracking activity on our site. This allows us to better understand how many people use our site and which pages and features are most popular.
            </p>


            <ul>
            The only information we normally collect and store is:
            <li>The name of your Internet service provider</li>
            <li>The web site that referred you to us (if any)</li>
            <li>The date and time the pages were accessed</li>
            <li>The page or pages you requested</li>
            <li>We reserve the right to change our privacy policy. 
              <br />A revised policy statement will only apply to data collected subsequent to its effective date. 
              <br />Any revisions will be posted at least 30 days prior to its effective date.</li>
            </ul>
            <p>
            3rd party advertisers may use cookies (delivered from their servers/service) to better tailor advertsing to the user. We use third-party advertising companies to serve ads when you visit our website. These companies may use information (not including your name, address, email address, or telephone number) about your visits to this and other websites in order to provide advertisements about goods and services of interest to you.
            <br /><br />
            For example, Google, as a third party vendor, uses cookies to serve ads on the RealTimeTouch.com website. Google's use of the DART cookie enables it to serve ads to users based on their visit to sites and other sites on the Internet. Users may opt out of the use of the DART cookie by visiting the Google ad and content network privacy policy: http://www.google.com/privacy_ads.html
            </p>
            <p>
              There are instances where you may elect to provide us with personal information, such as with a signup, login or shared social media logins such as with Facebook, Twitter, Google, etc.. </p>
              <p>
              If you fill out one of our feedback or request forms or send us email, you are transmitting the information that appears to you in the form or the message. This will typically include information like your name, social media, mailing address, email address, the kind of request you are making, and any other information necessary to fulfill your request. You never transmit personally identifying information that you do not enter yourself. And this is always your option; this information cannot be collected unless you specifically elect to send it to us. This information is used internally only for the purpose of fulfilling the request or for contacting you directly and is not given or sold to any other organization.
            </p>
            <p style={{paddingBottom:30}}>
            RealTimeTouch.com.com provides public information, published news, research and market data and our proprietary software tools to help our website visitor ("USER") research, organize and view that data on our website. 
            </p>
            <p>
              We hope you find our website useful and informative and are always willing to answer questions and receive suggestions. If you have either, please contact us at our <a href="/contact/">contact form</a>. Thank you.
            </p>

          </div>
        </div>
      </Fragment>
    )
  }
 }

export default PrivacyPage;


// WEBPACK FOOTER //
// ./src/pages/PrivacyPage/PrivacyPage.js